/**
 * Formats a Date to YYYY-MM-DD using local date (avoids timezone shifting with toISOString).
 */
function toLocalDateString(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/**
 * Parses a month/date value (from input type="month" or "date") and returns a YYYY-MM-DD string
 * for the backend, using local date to avoid timezone shifts.
 */
export const toBackendMonthDate = (value: string | Date | undefined): string | null => {
  if (!value) return null;
  const isMonthInput = typeof value === 'string' && value.length === 7;
  const date = isMonthInput ? new Date(value + '-01') : typeof value === 'string' ? new Date(value) : value;
  if (!(date instanceof Date) || isNaN(date.getTime())) return null;
  return toLocalDateString(date);
};

/**
 * Formats a form value (Date or YYYY-MM-DD string) to YYYY-MM for <input type="month"> display.
 * Uses local month/year to avoid timezone shifts.
 */
export const toMonthInputValue = (value: string | Date | null | undefined): string => {
  if (value == null || value === '') return '';
  const date = typeof value === 'string' ? new Date(value) : value;
  if (isNaN(date.getTime())) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  return `${y}-${m}`;
};
